import GlobalStyles from "./GlobalStyles";
import DefaultTheme from "../Themes/DefaultTheme";

const SellerAvailabilityCalendarModalStyles = (Theme) => ({
  ...GlobalStyles(Theme),
  modalTitle: {
    color: DefaultTheme.palette.dark.lightAlternative,
    margin: "1.75rem 0 0.875rem",
    fontWeight: "700",
    display: "inline-block",
    position: "relative",
    textAlign: "center",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
  },
  dialogTitle: {
    textAlign: "center"
  },
});

export default SellerAvailabilityCalendarModalStyles;
